import * as React from 'react';

var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgMapPinGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.459,
    height: 16.05,
    viewBox: "0 0 13.459 16.05"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".MapPinGrey_svg__map-pin-grey-b{fill:none;stroke:#08123b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.9 .9)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "MapPinGrey_svg__map-pin-grey-b",
    d: "M11.659 5.83c0 4.534-5.83 8.42-5.83 8.42S0 10.364 0 5.83a5.83 5.83 0 1111.659 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "MapPinGrey_svg__map-pin-grey-b",
    cx: 1.943,
    cy: 1.943,
    r: 1.943,
    transform: "translate(3.886 3.886)"
  }))));
}

export { SvgMapPinGrey as ReactComponent };
//# sourceMappingURL=MapPinGrey.svg.js.map
